/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ID } from '@gh/common-shared-data';
import { AbstractRestService, RestSettings } from '@gh/core-data';

import { Observable } from 'rxjs';

import {
  ContracturalCompletionRequestDto,
  ContracturalCompletionResponseDto,
  JobDatesTabInfoDto,
} from './job-dates.dto';
import {
  contracturalCompletionRequestMappper,
  contracturalCompletionResponseMapper,
  JobDatesInfoMapper,
} from './job-dates.mapper';

@Injectable()
export class JobDatesRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(jobId: ID): Observable<JobDatesTabInfoDto> {
    return this.httpGet(
      `${this.bp}/jobs/${jobId}/dates`,
      JobDatesInfoMapper,
    );
  }

  update(jobId: ID, jobDate: JobDatesTabInfoDto): Observable<JobDatesTabInfoDto> {
    return this.httpPut(
      `${this.bp}/jobs/${jobId}/dates`,
      jobDate,
      JobDatesInfoMapper,
    );
  }

  getContracturalCOmpletion(jobId: ID, contracturalCompletion: ContracturalCompletionRequestDto):
    Observable<ContracturalCompletionResponseDto> {
    return this.httpPost(
      `${this.bp}/jobs/${jobId}/dates/contractural-completion`,
      contracturalCompletion,
      contracturalCompletionRequestMappper,
      contracturalCompletionResponseMapper,
    );
  }
}
